import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { SCHEDULE_API_ROUTES } from "../utils/scheduleApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = SCHEDULE_API_ROUTES.scheduleTypes;

export async function getScheduleTypes() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch schedule types");
  return data;
}

export async function getScheduleTypesDropdown() {
  const res = await authFetch(`${BASE}/dropdown`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch schedule types");
  return data;
}

export async function createScheduleType(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create schedule type");
  return data;
}

export async function updateScheduleType(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update schedule type");
  return data;
}

export async function changeScheduleTypeStatus(id, statusId, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}/status`, {
    method: "PATCH",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify({ status_id: Number(statusId) }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to change schedule type status");
  return data;
}

export async function deleteScheduleType(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete schedule type");
  return data;
}
